import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import {
  Condition,
  PriceOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface NonReturnedValueState {
  amount: string;
  priceOption: PriceOption | null;
}

export const NON_RETURNED_VALUE = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<NonReturnedValueState>
  >,
): ConditionType<NonReturnedValueState, Condition.NonReturnedValue> => ({
  name: "Non-returned value",
  description(state) {
    if (!state.priceOption) {
      return "The total return value of all items in the order that the customer is not returning";
    }
    return `The total return value of all items not returned is ${state.priceOption.toLowerCase()} ${moneyFormat({ amount: +state.amount, currency: DEFAULT_CURRENCY })}`;
  },
  Details(props: ConditionTypeDetailsProps<NonReturnedValueState>) {
    return React.createElement(Details, props);
  },
  empty: { amount: (0).toFixed(2), priceOption: null },
  fromModel(model) {
    return { amount: model.amount.toFixed(2), priceOption: model.priceOption };
  },
  toModel(state) {
    return {
      type: Condition.NON_RETURNED_VALUE,
      amount: +state.amount,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return +state.amount >= 0 && state.priceOption !== null;
  },
});
